import React, { Suspense } from "react";
import { withSentryRoutes } from "../../tracing/sentry";
import { HashRouter, Route } from "react-router-dom";

type RouteConfig = {
    path: string;
    element: React.ComponentType;
};

type WithRoutesProps = {
    routes: RouteConfig[];
    children?: React.ReactNode;
};

export const withRoutes =
    (
        Component: React.ComponentType<
            WithRoutesProps & { children: React.ReactNode }
        >,
    ) =>
    (props: WithRoutesProps) => {
        const Routes = withSentryRoutes();

        const routes = props.routes.reduce<RouteConfig[]>(
            (injectedRoutes, route) => {
                return [
                    ...injectedRoutes,
                    { ...route, path: `/:lang${route.path}` },
                ];
            },
            [...props.routes],
        );

        return (
            <Suspense>
                <HashRouter>
                    <Component {...props}>
                        <Routes>
                            {routes.map((route) => (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    element={<route.element />}
                                />
                            ))}
                        </Routes>
                    </Component>
                </HashRouter>
            </Suspense>
        );
    };
